import { ReactNode } from 'react'
import MaintenanceBanner from '../ui/MaintenanceBanner'
import { authPageClass } from './authTheme'

interface AuthShellProps {
  children: ReactNode
  wide?: boolean
}

export default function AuthShell({ children, wide }: AuthShellProps) {
  return (
    <>
      {/* Auth routes sit outside MainLayout — still show deploy maintenance UX. */}
      <MaintenanceBanner />
      <div className={authPageClass}>
        <div className={`w-full space-y-8 ${wide ? 'max-w-lg' : 'max-w-md'}`}>{children}</div>
      </div>
    </>
  )
}
